// @flow
import config from '../package.json';

const ID = `${config.name}/actions/muleCustStateActions.js`;
const createActionName = (name: string) => `app/${ID}/${name}`;

// -- RED DOT --
export const FETCH_MULE_RED_DOT_STATE_REQUEST = createActionName(
  'FETCH_MULE_RED_DOT_STATE_REQUEST',
);
export const FETCH_MULE_RED_DOT_STATE_SUCCESS = createActionName(
  'FETCH_MULE_RED_DOT_STATE_SUCCESS',
);
export const FETCH_MULE_RED_DOT_STATE_FAILURE = createActionName(
  'FETCH_MULE_RED_DOT_STATE_FAILURE',
);
export const REFRESH_MULE_RED_DOT_STATE_REQUEST = createActionName(
  'REFRESH_MULE_RED_DOT_STATE_REQUEST',
);
export const REFRESH_MULE_RED_DOT_STATE_SUCCESS = createActionName(
  'REFRESH_MULE_RED_DOT_STATE_SUCCESS',
);
export const REFRESH_MULE_RED_DOT_STATE_FAILURE = createActionName(
  'REFRESH_MULE_RED_DOT_STATE_FAILURE',
);
export const UPDATE_MULE_RED_DOT_REQUEST = createActionName(
  'UPDATE_MULE_RED_DOT_REQUEST',
);

// -- GENERAL ACTION FOR ACCESS MULE CUSTOMER STATE --
export const FETCH_MULE_CUST_STATE_REQUEST = createActionName(
  'FETCH_MULE_CUST_STATE_REQUEST',
);
export const FETCH_MULE_CUST_STATE_SUCCESS = createActionName(
  'FETCH_MULE_CUST_STATE_SUCCESS',
);
export const FETCH_MULE_CUST_STATE_FAILURE = createActionName(
  'FETCH_MULE_CUST_STATE_FAILURE',
);
export const REFRESH_MULE_CUST_STATE_REQUEST = createActionName(
  'REFRESH_MULE_CUST_STATE_REQUEST',
);
export const REFRESH_MULE_CUST_STATE_SUCCESS = createActionName(
  'REFRESH_MULE_CUST_STATE_SUCCESS',
);
export const REFRESH_MULE_CUST_STATE_FAILURE = createActionName(
  'REFRESH_MULE_CUST_STATE_FAILURE',
);
export const RESET_MULE_CUST_STATE_REQUEST = createActionName(
  'RESET_MULE_CUST_STATE_REQUEST',
);
export const UPDATE_MULE_CUST_STATE_REQUEST = createActionName(
  'UPDATE_MULE_CUST_STATE_REQUEST',
);

export const fetchMuleRedDotStateRequest = () => {
  console.log('fetchMuleRedDotStateRequest');
  return {
    type: FETCH_MULE_RED_DOT_STATE_REQUEST,
    succcessAction: FETCH_MULE_RED_DOT_STATE_SUCCESS,
    failureAction: FETCH_MULE_RED_DOT_STATE_FAILURE,
  };
};
export const refreshMuleRedDotStateRequest = () => {
  console.log('refreshMuleCustStateRequest');
  return {
    type: REFRESH_MULE_RED_DOT_STATE_REQUEST,
    succcessAction: REFRESH_MULE_RED_DOT_STATE_SUCCESS,
    failureAction: REFRESH_MULE_RED_DOT_STATE_FAILURE,
  };
};
export const updateMuleRedDotState = (clickedWebinarEventIds: string[]) => {
  console.log('updateMuleRedDotState');
  return {
    type: UPDATE_MULE_RED_DOT_REQUEST,
    payload: {
      clickedWebinarEventIds,
    },
  };
};

export const fetchMuleCustStateRequest = (
  custKey: string,
  successAction: string,
  failedAction: string,
) => {
  console.log('fetchMuleCustStateRequest');
  return {
    type: FETCH_MULE_CUST_STATE_REQUEST,
    succcessAction: successAction,
    failureAction: failedAction,
    custKey: custKey,
  };
};

export const refreshMuleCustStateRequest = (custKey: string) => {
  console.log('refreshMuleCustStateRequest');
  return {
    type: REFRESH_MULE_CUST_STATE_REQUEST,
    succcessAction: REFRESH_MULE_CUST_STATE_SUCCESS,
    failureAction: REFRESH_MULE_CUST_STATE_FAILURE,
    custKey: custKey,
  };
};

/**
 *
 * @param {*} featureId The clicked featureId
 * @param {*} custKey
 * @param {*} originalValue
 */
export const updateMuleCustState = (
  custKey: string,
  originalValue: string,
  newValue: string,
  refreshAction: string,
) => {
  console.log('updateMuleCustState');
  return {
    type: UPDATE_MULE_CUST_STATE_REQUEST,
    refreshAction: refreshAction,
    payload: {
      newValue,
      custKey,
      originalValue,
    },
  };
};

export const resetMuleCustState = (refreshAction: string, custKey: string) => {
  console.log('resetMuleCustState');
  return {
    type: RESET_MULE_CUST_STATE_REQUEST,
    refreshAction: refreshAction,
    custKey: custKey,
  };
};
